export default  class Utils {
    static isDevEnvironment() {
      return window.location.hostname != 'admin.smart.electronauts.net';
    }
}



// WEBPACK FOOTER //
// ./src/Utils.js